import { Box, Button, FormControlLabel, Paper, Switch, Typography } from "@mui/material";
import { useState } from "react";

import type { AccountSectionProps } from "./account-general-section";
import type { FC } from "react";

const CHANNEL_FIELDS = [
  ["enable_slack", "Slack"],
  ["enable_teams", "Teams"],
  ["enable_twilio", "Twilio (SMS)"],
  ["enable_whatsapp", "WhatsApp"],
  ["enable_work_email", "Work Email"],
  ["enable_personal_email", "Personal Email"],
] as const;

type ChannelField = (typeof CHANNEL_FIELDS)[number][0];

export const AccountChannelsSection: FC<AccountSectionProps> = ({ account, onSave }) => {
  const [channels, setChannels] = useState<Record<ChannelField, boolean>>({
    enable_slack: account.enable_slack,
    enable_teams: account.enable_teams,
    enable_twilio: account.enable_twilio,
    enable_whatsapp: account.enable_whatsapp,
    enable_work_email: account.enable_work_email,
    enable_personal_email: account.enable_personal_email,
  });
  const [saving, setSaving] = useState(false);

  const save = async (): Promise<void> => {
    setSaving(true);
    try {
      await onSave(channels);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Paper id="channels" elevation={24} sx={{ p: 4 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Channels
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
          gap: 1,
        }}
      >
        {CHANNEL_FIELDS.map(([field, label]) => (
          <FormControlLabel
            key={field}
            control={
              <Switch
                checked={channels[field]}
                onChange={(e) => setChannels((prev) => ({ ...prev, [field]: e.target.checked }))}
              />
            }
            label={label}
          />
        ))}
      </Box>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
        <Button
          data-analytics-id="ce-admin-save-channels"
          variant="contained"
          onClick={() => void save()}
          disabled={saving}
        >
          {saving ? "Saving…" : "Save"}
        </Button>
      </Box>
    </Paper>
  );
};
